import { render } from "./backgroundMedia.vue?vue&type=template&id=2e0d2a9d&scoped=true"
import script from "./backgroundMedia.vue?vue&type=script&lang=js"
export * from "./backgroundMedia.vue?vue&type=script&lang=js"

import "./backgroundMedia.vue?vue&type=style&index=0&id=2e0d2a9d&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0d2a9d"]])

export default __exports__